export default [
  {
    path: '/workflowdashboard',
    name: 'workflowdashboard',
    component: () => import ('@/views/workflow/WorkflowDashboard.vue'),
    meta: {
      resource: 'Workflow',
      action: 'create',
    },
  }
]
